import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpOutline } from "@mui/icons-material";
import { Dialog, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { Content, Questions, useQuestions } from "./index.js";
export function ContentWithQuestions({ tag, values, enabled = true, children, questionsChildren, ...props }) {
    const [showDialog, setDialog] = useState(false);
    const { breakpoints } = useTheme();
    const mdAndUp = useMediaQuery(breakpoints.up("md"));
    const questions = useQuestions(tag);
    const toggleDialog = () => setDialog(!showDialog);
    if (!enabled) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Content, { sidebar: mdAndUp &&
                    !!questions.length && (_jsx(Questions, { questions: questions, values: values, children: questionsChildren })), sx: { position: "relative" }, ...props, children: [!mdAndUp && !!questions.length && (_jsx(IconButton, { onClick: toggleDialog, sx: { position: "absolute", right: 4 }, children: _jsx(HelpOutline, {}) })), children] }), _jsx(Dialog, { open: showDialog, onClose: toggleDialog, children: _jsx(Questions, { questions: questions, values: values, sx: { mt: 0 }, children: questionsChildren }) })] }));
}
//# sourceMappingURL=ContentWithQuestions.js.map